/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainOrderStatus } from '../../entities/domain/OrderStatus'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainOrderStatusSchema = z.enum(['process', 'done', 'cancel']) as unknown as ToZod<DomainOrderStatus>